'use client';

import { useEffect, useState } from 'react';
import posthog from 'posthog-js';

import type { FlagMap } from './types';

export const useAnnouncementFlag = () => {
  const key = 'announcement';
  const [result, setResult] = useState(() => posthog.getFeatureFlagResult(key));

  useEffect(() => {
    return posthog.onFeatureFlags(() => {
      setResult(posthog.getFeatureFlagResult(key));
    });
  }, []);

  return {
    enabled: result?.enabled ?? false,
    payload: result?.payload as FlagMap['announcement'] | undefined,
  };
};

export const useMaintenanceModeFlag = () => {
  const key = 'maintenance-mode';
  const [enabled, setEnabled] = useState(() => posthog.isFeatureEnabled(key));

  useEffect(() => {
    return posthog.onFeatureFlags(() => {
      setEnabled(posthog.isFeatureEnabled(key));
    });
  }, []);

  return enabled ?? false;
};
